document.addEventListener("DOMContentLoaded", () => {

  const modal = document.getElementById("CustomQuickAddModal");
  const overlay = modal.querySelector(".cqa-overlay");
  const closeBtn = modal.querySelector(".cqa-close");
  const container = document.getElementById("CustomCardContainer");
 

  // WHEN USER CLICKS QUICK ADD BUTTON
  document.querySelectorAll("[data-custom-quick-add]").forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const productId = btn.dataset.productId;
      
      // find that card's hidden template
      const template = document.querySelector(
        `.cqa-hidden-template[data-product-id="${productId}"] .cqa-template-inner`
      );

      if (!template) {
        console.warn("CustomQuickAdd: No template found for product:", productId);
        return;
      }

      // clear existing modal content
      container.innerHTML = "";

      // clone the quick-buy layout
      const clone = template.cloneNode(true);

      // inject into modal
      container.appendChild(clone);

      // open modal
      modal.classList.remove("hidden");
    });
  });



  // CLOSE MODAL
  closeBtn.addEventListener("click", () => modal.classList.add("hidden"));
  
  overlay.addEventListener("click", () => modal.classList.add("hidden"));
 

  
});


// document.addEventListener("DOMContentLoaded", () => {
//   const modal = document.getElementById("CustomQuickAddModal");
//   const closeBtn = modal.querySelector(".cqa-close");
//   const overlay = modal.querySelector(".cqa-overlay");

//   const imgEl = document.getElementById("cqaProductImage");
//   const titleEl = document.getElementById("cqaProductTitle");
//   const priceEl = document.getElementById("cqaProductPrice");
//   const linkEl = document.getElementById("cqaViewProduct");

//   // Intercept Dawn Quick Add buttons
//  document.querySelectorAll("button.quick-add__submit[data-custom-quick-add]").forEach(btn => {
//     btn.addEventListener("click", async (e) => {
//       e.preventDefault();

//       const productUrl = btn.dataset.productUrl;
//       if (!productUrl) return;

//       // Fetch product JSON for custom modal
//       const productJson = await fetch(productUrl + ".js").then(r => r.json());

//       // Fill modal
//       imgEl.src = productJson.images[0];
//       titleEl.innerText = productJson.title;
//       priceEl.innerText = (productJson.price / 100).toLocaleString("en-IN", {
//         style: "currency",
//         currency: "INR"
//       });
//       linkEl.href = productUrl;

//       // Show modal
//       modal.classList.remove("hidden");
//     });
//   });

//   // Close modal
//   closeBtn.addEventListener("click", () => modal.classList.add("hidden"));
//   overlay.addEventListener("click", () => modal.classList.add("hidden"));
// });
